import React, { Component, Fragment } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'

import { apiConstants } from '../constants/apiConstants'
import {
  folderTreeStructure,
  sortFiles,
  removeExtraSlashes,
  checkEmailMaskBeforeRender,
} from '../helper'
import caller from '../caller'
import { filterFileList } from '../helpers/filter'

import { ReactComponent as FolderOpen } from '../images/folder-open-line.svg'
import { ReactComponent as FolderClose } from '../images/folder-line.svg'

class TreeView extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      queryRequest: [],
      folderList: {},
      isExpandAll: false,
      isFolderListFetchInProgress: false,
    }
  }

  componentDidMount() {
    this.fetchFolderData(apiConstants.Root)
  }

  componentWillUnmount() {
    this.abortRequests()
  }

  abortRequests = () => {
    const { queryRequest } = this.state
    queryRequest.forEach((request) => {
      if (request) request.abort()
    })
  }

  componentDidUpdate(_prevProps, _prevState) {
    const { refresh } = this.props

    if (refresh) {
      this.fetchFolderData(apiConstants.Root)
      this.props.setRefreshState(false)
    }
  }

  fetchFolderData = (path, from = '', internalFetch = false) => {
    const { user } = this.props

    let queryRequest = []

    this.abortRequests()
    if (from === '') {
      this.setProgress('isFolderListFetchInProgress', true)
      this.setProgress('isExpandAll', false)
    }

    const url = `${apiConstants.URLPrefix}/${user.accType}/${user.username}/path/${path}${apiConstants.SearchURLSuffix}`

    const params = {
      fileType: 'folder',
      sortType: 'asc',
      sortBy: 'fileName',
    }

    queryRequest.push(
      caller.search(url, params, (res) => {
        this.searchResult(res, internalFetch)
      }),
    )

    this.setState({ queryRequest })
  }

  searchResult(res, internalFetch) {
    const { folderList } = this.props
    if (res.status === 200) {
      const responseData = JSON.parse(res.text)
      const searchResult = _.get(responseData, 'results', [])
      const fileList = {
        total: searchResult.length,
        results: searchResult,
      }
      if (!internalFetch) {
        this.setFolderStructure(fileList)
        this.props.actions.setTree(fileList)
      } else {
        const newResult = fileList.results
        const finalResult = [...newResult, ...folderList.results]
        const folderListFinal = {
          total: finalResult.length,
          results: sortFiles(finalResult, 'fileName', 'asc'),
        }
        this.setFolderStructure(folderListFinal)
        this.props.actions.setTree(folderListFinal)
      }
    } else {
      const folderListFinal = {
        total: 0,
        results: [],
      }
      this.setFolderStructure(folderListFinal)
      this.props.actions.setTree(folderListFinal)
      this.props.setErrorMessage(res)
    }
    this.setProgress('isFolderListFetchInProgress', false)
  }

  setFolderStructure = (folderList) => {
    const folders = folderTreeStructure(
      filterFileList(sortFiles(folderList.results, 'fileName', 'asc'), {
        fileType: 'folder',
      }),
    )
    this.setState({ folderList: folders })
  }

  setProgress = (key, value) => {
    this.setState({ [key]: value })
  }

  onFolderNameClick = (item) => {
    const { folderList } = this.props
    const folders = folderList.results.filter(function (folder) {
      return removeExtraSlashes(folder.path) === removeExtraSlashes(item.path)
    })
    const folder = folders[0]

    this.props.treeViewFolderClick(folder)
    this.props.history.push(`${apiConstants.URLPrefix}${folder.fileName}`)
  }

  expandCollapseFolder = (isExpandAll) => {
    this.setState({ isExpandAll })
    let details = document.getElementsByClassName('folderDetails')
    for (let item of details) {
      if (isExpandAll) {
        item.setAttribute('open', 'true')
      } else {
        item.removeAttribute('open')
      }
    }
  }

  calculateListPosition = (folderList, item, isRoot) => {
    let style = {}
    const folders = Object.keys(folderList[item])
    if (
      (folders.length === 1 && isRoot) ||
      (folders.length > 1 && isRoot) ||
      (folders.length === 1 && folders[0] === 'path')
    ) {
      style = { left: '10px' }
    } else if (folders.length > 1) {
      style = { left: '15px' }
    }
    return style
  }

  checkFolderIsOpen = (item) => {
    const { baseFolder } = this.props
    const folders = removeExtraSlashes(baseFolder).split('/')
    return folders[folders.length - 1] === item
  }

  onMouseOver = (e) => {
    const rect = e.target.getBoundingClientRect()
    if (e.target.children[0]) {
      e.target.children[0].style.top = `${rect.top + 10}px`
      e.target.children[0].style.left = `${rect.left + 10}px`
    }
  }

  toggleDetails = (evt, value, item) => {
    const { folderList } = this.state
    const target = evt.target.children[0].children[0]
    if (target && evt.target.open) {
      target.classList.add('arrow-bottom')
      target.classList.remove('arrow-right')
      if (evt.target.dataset.text === item) {
        const data = removeExtraSlashes(value.path).split('/')
        this.updateSpinStatus(folderList, value.path, data, data.length, 0)

        const path = removeExtraSlashes(value.path)
        this.fetchFolderData(path, 'internal', true)
      }
    } else if (target && !evt.target.open) {
      target.classList.remove('arrow-bottom')
      target.classList.add('arrow-right')
    }
  }

  updateSpinStatus = (folderList, path, data, length, i) => {
    if (i < length) {
      if (folderList[data[i]].path === path) {
        folderList[data[i]].spin = true
      } else {
        this.updateSpinStatus(folderList[data[i]], path, data, length, i + 1)
      }
    }
  }

  list = (folderList, isRoot, user) => {
    return Object.keys(folderList).map((item, index) => {
      const folderName = checkEmailMaskBeforeRender({}, item, folderList, true)
      return item !== 'path' &&
        item !== 'spin' &&
        item !== 'enableEmailMask' ? (
        <li
          className={`${
            isRoot ? 'tree__folder-list-item' : 'tree__sub-folder-list-item'
          } vx_text-body_secondary tree__folder`}
          key={index}
        >
          <div
            style={this.calculateListPosition(folderList, item, isRoot)}
            className="tree__folder-list tree__folder-list--open tree__folder-list--absolute flexAlignCenter"
          >
            <div className="tree__folder-icon--orange">
              {this.checkFolderIsOpen(item) ? <FolderOpen /> : <FolderClose />}
            </div>
            <div
              className={`tree__folder-name ${
                this.checkFolderIsOpen(item)
                  ? 'tree__folder-name--selected'
                  : ''
              }`}
              data-pa-pgrp={`dropzone:${user.accType}`}
              data-pa-page={`dropzone:search:hierarchy:folder:${user.accType}`}
              data-pa-click="hierarchy_folder"
              onClick={() => this.onFolderNameClick(folderList[item])}
            >
              <div className="tooltip" onMouseOver={(e) => this.onMouseOver(e)}>
                <Fragment>
                  {folderName.length > 23
                    ? `${folderName.substring(0, 23)}...`
                    : folderName}
                  {folderName.length > 23 && (
                    <span className="tooltiptext">{folderName}</span>
                  )}
                </Fragment>
              </div>
            </div>
          </div>

          <details
            className="folderDetails"
            data-text={item}
            data-pa-pgrp={`dropzone:${user.accType}`}
            data-pa-page={`dropzone:search:hierarchy:folder:${user.accType}`}
            data-pa-click="hierarchy_folder"
            onToggle={(e) => this.toggleDetails(e, folderList[item], item)}
          >
            <summary>
              <div
                data-text={Object.keys(folderList[item])[0]}
                className="arrow-right pointer"
              />
            </summary>
            <div className="tree__outline tree_root">
              <ul>{this.list(folderList[item], false, user)}</ul>
            </div>
          </details>
        </li>
      ) : (
        this.renderSpin(item, folderList)
      )
    })
  }

  renderSpin = (item, folderList) => {
    return item === 'spin' && folderList[item] === true ? (
      <div className="tree__view-spinner" key="spinner">
        <p
          className="ppvx_loading-spinner"
          style={{
            width: '15px',
            height: '15px',
            margin: '0px',
          }}
        >
          <span className="ppvx_loading-spinner__screenreader" />
        </p>
      </div>
    ) : (
      ''
    )
  }

  renderExpandCollapseLink = (expand) => (expand ? 'Collapse All' : '')

  renderDummyTree = () => {
    return (
      <ul className="list-container--dummy">
        <li className="list-dummy" />
        <li className="list-dummy" />
        <li className="list-dummy" />
      </ul>
    )
  }

  renderFolderTree = () => {
    const { isExpandAll, folderList, isFolderListFetchInProgress } = this.state
    const { user } = this.props
    return (
      <div className="tree__holder">
        <h3 className="ppvx_text--md tree__header">
          <div
            data-pa-pgrp={`dropzone:${user.accType}`}
            data-pa-page={`dropzone:search:hierarchy:home:${user.accType}`}
            data-pa-click="hierarchy_home"
            onClick={() => this.fetchFolderData(apiConstants.Root, '', true)}
          >
            <Message id="labels.tree.title" />
          </div>
          <span
            className="ppvx_text--sm tree__expand-collapse"
            onClick={() => this.expandCollapseFolder(!isExpandAll)}
          >
            {Object.keys(folderList).length > 1
              ? this.renderExpandCollapseLink(isExpandAll)
              : ''}
          </span>
        </h3>
        {isFolderListFetchInProgress ? (
          this.renderDummyTree()
        ) : (
          <ul className="tree__folder-list-view">
            {this.list(folderList, true, user)}
          </ul>
        )}
      </div>
    )
  }

  render() {
    return this.renderFolderTree()
  }
}

export default TreeView
